import React, { useEffect, useRef } from "react";
import {
  Tooltip,
  makeStyles,
  TableCell,
  TableRow,
  TableCellLayout,
  PopoverTrigger,
  Popover,
  PopoverSurface,
} from "@fluentui/react-components";
import { useState } from "react";
import {
  FlagIcon,
  MeatBallsMenuIcon,
  PlusIcon,
} from "../../../../../modules/default-svg";
import CustomInput from "../../../input/customInput/CustomInput";
import TextArea from "../../../textarea/Textarea";
import {
  createRoleRequest,
  updateRoleRequest,
} from "../../../../../store/actions/user.actions";
import { useDispatch } from "react-redux";
import { generalActions } from "../../../../../store/actions";

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: "#342c82",
    color: "#FFFFFF",
  },
});

const RolesRow = (props) => {
  const {
    sortingCriteria,
    data,
    handleModal,
    menu,
    sortRolesRequest,
    updateFlag,
    columnConfig,
  } = props;
  const [flagged, setFlagged] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  const [popoverOpen, setPopoverOpen] = useState("");
  const [isEditRecord, setIsEditRecord] = useState(null);
  const popoverRef = useRef(null);
  const nameInputRef = useRef(null);
  const descriptionInputRef = useRef(null);
  const dispatch = useDispatch();
  const [formErrors, setFormErrors] = useState({
    name: "",
  });

  const handleBlur = () => {
    let data = { ...isEditRecord?.name };
    if (data?.name?.length > 0) {
      if (data.id) {
        dispatch(
          updateRoleRequest({
            id: sortedData[isEditRecord.index].id,
            name: data.name,
            description: data.description,
          })
        );
      } else {
        dispatch(createRoleRequest({ ...data }));
      }
      setIsEditRecord(null);
    } else {
      const errors = {};
      if (!data.name) {
        errors["name"] = `The Name field is required.`;
        setFormErrors(errors);
        return dispatch(
          generalActions.showToast({
            title: "name is a required field",
            type: "error",
          })
        );
      }
    }
  };

  const handleEditable = (event) => {
    if (event.key === "Escape") {
      setIsEditRecord(null);
    } else if (event.key === "Enter") {
      if (isEditRecord) {
        handleBlur();
      }
    }
  };

  useEffect(() => {
    if (sortingCriteria.column !== null) {
      sortRolesRequest({
        page: 1,
        size: 10,
        orderBy: `${sortingCriteria.column} ${sortingCriteria.order}`,
      });
    }
  }, [sortingCriteria]);

  useEffect(() => {
    if (typeof data != "string") {
      data
        .filter((d) => d.isFlagged)
        .map((f) => {
          if (!flagged.includes(f.id)) {
            setFlagged((prevItems) => [...prevItems, f.id]);
          }
        });
      let tempDate = [...data];
      tempDate.push({ name: "", description: "" });
      setSortedData(tempDate);
    }
  }, [data]);

  useEffect(() => {
    if (menu.props.closePopover) {
      setPopoverOpen(null);
    }
  }, [menu.props.closePopover]);

  const handlePopoverOpen = (rowId) => {
    setPopoverOpen(rowId);
  };

  const handleClickOutside = (event) => {
    if (
      popoverRef.current &&
      !popoverRef.current.contains(event.target) &&
      event.target?.innerText !== "Edit" &&
      event.target?.innerText !== "Delete" &&
      event.target?.innerText !== "Permissions" &&
      event.target?.innerText !== "Remind me"
    ) {
      if (popoverOpen) {
        handlePopoverOpen(null);
      }
    }
    if (
      // textarea
      isEditRecord &&
      event.target.localName !== "input" &&
      event.target.localName !== "textarea" &&
      event.target.localName !== "div"
    ) {
      handleBlur();
    } else if (isEditRecord && event.target.placeholder === "Search") {
      handleBlur();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEditable);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEditable);
    };
  }, [isEditRecord, popoverOpen]);

  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////

  const addFlag = (id) => {
    setFlagged((prevItems) => [...prevItems, id]);
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: true,
        },
      ],
    });
  };

  const removeFlag = (id) => {
    setFlagged((prevItems) => prevItems.filter((item) => item !== id));
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: false,
        },
      ],
    });
  };

  useEffect(() => {
    const sortedArray = data;
    let tempDate = [...sortedArray];
    tempDate.push({ name: "", description: "" });
    setSortedData(tempDate);
  }, [flagged]);

  const sortDataByFlagged = (dataArray, flaggedArray) => {
    const flaggedItems = [];
    const remainingItems = [];

    dataArray.forEach((item) => {
      if (flaggedArray.includes(item.id)) {
        flaggedItems.push(item);
      } else {
        remainingItems.push(item);
      }
    });

    flaggedItems.sort((a, b) => {
      return flaggedArray.indexOf(a.id) - flaggedArray.indexOf(b.id);
    });

    return [...flaggedItems, ...remainingItems];
  };

  const handleInputChange = (value, type) => {
    const data = JSON.parse(JSON.stringify(isEditRecord));
    if (type === "name") {
      formErrors["name"] = "";
      data.name.name = value;
      setIsEditRecord(data);
    } else {
      data.name.description = value;
      setIsEditRecord(data);
    }
  };

  const handleIsEdiRecord = (index, type) => {
    if (index === data.length && type !== "scope") {
      sortedData[index] = {
        ...isEditRecord?.name,
      };
    }
    setIsEditRecord({ index: index, name: sortedData[index] });
    setTimeout(() => {
      switch (type) {
        case "name":
          nameInputRef.current?.focus();
          break;
        case "description":
          descriptionInputRef.current?.focus();
          break;
      }
    }, 0);
  };

  //   const handleSave = () => {
  //     const errors = {};
  //     if (!name) errors['name'] = `Name field is required.`;
  //     setFormErrors(errors);
  //     if (Object.keys(errors).length) {
  //         return;
  //     }
  //     if (Object.keys(selectedRow).length > 0) {
  //         updateRoleRequest({ id: selectedRow.id, name, description });
  //     } else {
  //         createRoleRequest({ name, description });
  //     }
  // };

  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////

  const sortedColumnConfig = [...columnConfig].sort(
    (a, b) => a.order - b.order
  );

  const renderTableCell = (item, index, column) => {
    const isEditing = isEditRecord && isEditRecord.index === index;

    switch (column.label) {
      case "Name":
        return (
          <TableCell>
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center inputWidth">
                {item?.id && (
                  <Tooltip
                    positioning="before"
                    content={{
                      children: flagged.includes(item.id) ? "Unflag" : "Flag",
                      className: styles.tooltip,
                    }}
                    relationship="label"
                    withArrow
                  >
                    <span
                      className={`flag ${
                        flagged.includes(item.id) ? "flagActive" : ""
                      }`}
                      onClick={() =>
                        flagged.includes(item.id)
                          ? removeFlag(item.id)
                          : addFlag(item.id)
                      }
                    >
                      <FlagIcon />
                    </span>
                  </Tooltip>
                )}
                {isEditing ? (
                  <CustomInput
                    placeholder="Enter Role"
                    handleChange={(value) => handleInputChange(value, "name")}
                    type="text"
                    value={isEditRecord.name.name}
                    ref={nameInputRef}
                    width={"100%"}
                    errorMessage={formErrors.name}
                    displayErrorMessage={false}
                  />
                ) : (
                  <span
                    className="inputWidth"
                    onClick={() => handleIsEdiRecord(index, "scope")}
                  >
                    {item?.id ? (
                      item.name
                    ) : (
                      <div className="d-flex _add_btn">
                        <PlusIcon />
                        Add
                      </div>
                    )}
                    {item.isDefault && (
                      <span className="pill purple m-2">Default role</span>
                    )}
                  </span>
                )}
              </div>
              {item?.id && (
                <div className="flag">
                  <Popover
                    {...props}
                    open={popoverOpen === item.id}
                    onOpenChange={(isOpen) =>
                      isOpen && handlePopoverOpen(item.id)
                    }
                    positioning="below-start"
                  >
                    <PopoverTrigger disableButtonEnhancement>
                      <TableCellLayout
                        media={<MeatBallsMenuIcon />}
                        onClick={(e) => {
                          e.preventDefault();
                          handleModal(item);
                        }}
                      />
                    </PopoverTrigger>
                    <PopoverSurface
                      tabIndex={-1}
                      className="listingPopoverWrapper"
                    >
                      {menu}
                    </PopoverSurface>
                  </Popover>
                </div>
              )}
            </div>
          </TableCell>
        );
      case "Description":
        return isEditing ? (
          <TableCell>
            <TextArea
              textAreaFieldSize="textArea_small"
              placeholder="Enter Description"
              onChange={(value) => handleInputChange(value, "description")}
              value={isEditRecord.name.description}
              ref={descriptionInputRef}
            />
          </TableCell>
        ) : (
          <TableCell onClick={() => handleIsEdiRecord(index, "description")}>
            <div>{item.description}</div>
          </TableCell>
        );
      default:
        return null;
    }
  };

  const styles = useStyles();
  return sortedData.map((item, index) => (
    <TableRow key={item.id || index} ref={popoverRef}>
      {sortedColumnConfig
        .filter((column) => column.isVisible)
        .map((col) => renderTableCell(item, index, col))}
    </TableRow>
  ));
};

export default RolesRow;
